import { SerializerOptions } from "../index";
import { DriverProfileDtoSerializer } from "./DriverProfileDtoSerializer";
import { FleetDtoSerializer } from "./FleetDtoSerializer";
import { FleetTagCategoryDtoSerializer } from "./FleetTagCategoryDtoSerializer";
import { TagCategoryTagDtoSerializer } from "./TagCategoryTagDtoSerializer";
import { TagDtoSerializer } from "./TagDtoSerializer";

const typeSerializerMap = new Map<string, <T extends { __typename?: any }, P extends Object>(entity: T, options: SerializerOptions<T, P>) => any>();

typeSerializerMap.set(TagDtoSerializer.type, TagDtoSerializer.serializer);
typeSerializerMap.set(FleetDtoSerializer.type, FleetDtoSerializer.serializer);
typeSerializerMap.set(FleetTagCategoryDtoSerializer.type, FleetTagCategoryDtoSerializer.serializer);
typeSerializerMap.set(TagCategoryTagDtoSerializer.type, TagCategoryTagDtoSerializer.serializer);
typeSerializerMap.set(DriverProfileDtoSerializer.type, DriverProfileDtoSerializer.serializer);

export default typeSerializerMap;
